import { GoogleMap, Marker, InfoWindow } from '@react-google-maps/api'
import { useState } from 'react'
import type { Location } from '@/lib/types/map'
import { LocationCard } from './LocationCard'

interface GoogleMapProps {
	locations: Location[]
}

export default function Map({ locations }: GoogleMapProps) {
	const [selectedMarker, setSelectedMarker] = useState<Location | null>(null)
	const mapContainerStyle = {
		width: '100%',
		height: '620px',
	}

	const center = {
		lat: locations[0]?.latitude || 0,
		lng: locations[0]?.longitude || 0,
	}

	return (
		<GoogleMap mapContainerStyle={mapContainerStyle} zoom={4.5} center={center}>
			{locations.map((location) => (
				<Marker
					key={location.id}
					position={{
						lat: location.latitude,
						lng: location.longitude,
					}}
					title={location.dealer_name}
					clickable={true}
					onClick={() => setSelectedMarker(location)}
				/>
			))}

			{selectedMarker && (
				<InfoWindow
					position={{
						lat: selectedMarker.latitude,
						lng: selectedMarker.longitude,
					}}
					onCloseClick={() => setSelectedMarker(null)}
				>
					<LocationCard {...selectedMarker} className="!pt-0 !px-4 !pb-4 w-[300px]" />
				</InfoWindow>
			)}
		</GoogleMap>
	)
}
